
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/size-guide",
      function () {
        return require("private-next-pages/size-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/size-guide"])
      });
    }
  